let Components = {};

Components["CategoriesStatic"] = require("./CategoriesStatic").default;
Components["CategoriesDynamic"] = require("./CategoriesDynamic").default;

export default Components;
